__turbopack_context__.v({
  "getAppLink": "_85i50G_getAppLink",
  "headerExtensionWrapper": "_85i50G_headerExtensionWrapper",
});
